import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, zoneAddedAction } from '../../reducers/actions';
import { ZoneService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.ADD_ZONE),
    switchMap(action =>
      ZoneService.create(action.zone, store).pipe(
        map(zone => zoneAddedAction(zone)),
        catchError(retryAuthentication(action$, 'epics/zones/zoneAdd'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/zones/zoneAdd.js